module.exports = __webpack_public_path__ + "img/six-7.d66e18cc.png";